/** Kỳ xem của màn Giao dịch: tháng, quý hoặc cả năm. Thuần hàm, có test. */
export type PeriodMode = 'month' | 'quarter' | 'year';
export interface Period { mode: PeriodMode; year: number; month: number; quarter: number }

export const quarterOf = (month: number) => Math.ceil(month / 3);

export const currentPeriod = (now: Date = new Date(), mode: PeriodMode = 'month'): Period =>
  ({ mode, year: now.getFullYear(), month: now.getMonth() + 1, quarter: quarterOf(now.getMonth() + 1) });

/** Đổi chế độ: giữ năm; quý lấy quý chứa tháng đang xem, tháng lấy tháng đầu của quý đang xem. */
export const switchMode = (p: Period, mode: PeriodMode): Period => {
  if (mode === p.mode) return p;
  if (mode === 'quarter') return { ...p, mode, quarter: quarterOf(p.month) };
  if (mode === 'month') return { ...p, mode, month: p.mode === 'quarter' ? (p.quarter - 1) * 3 + 1 : p.month };
  return { ...p, mode };
};

/** Lùi/tiến một kỳ (qua năm tự động). */
export const stepPeriod = (p: Period, delta: number): Period => {
  if (p.mode === 'year') return { ...p, year: p.year + delta };
  if (p.mode === 'quarter') {
    const idx = p.year * 4 + (p.quarter - 1) + delta;
    return { ...p, year: Math.floor(idx / 4), quarter: (idx % 4 + 4) % 4 + 1 };
  }
  const idx = p.year * 12 + (p.month - 1) + delta;
  return { ...p, year: Math.floor(idx / 12), month: (idx % 12 + 12) % 12 + 1 };
};

/** Tham số cho filterEntries. */
export const periodFilter = (p: Period): { year: number; month: number | null; quarter: number | null } =>
  ({ year: p.year, month: p.mode === 'month' ? p.month : null, quarter: p.mode === 'quarter' ? p.quarter : null });

export const periodTitle = (p: Period): string => (p.mode === 'year' ? 'Cả năm' : p.mode === 'quarter' ? `Quý ${p.quarter}` : `Tháng ${p.month}`);

/** Các tháng (năm, tháng) thuộc kỳ — dùng để gộp dữ liệu theo tháng thành quý/năm. */
export const periodMonths = (p: Period): Array<{ y: number; m: number }> => {
  if (p.mode === 'month') return [{ y: p.year, m: p.month }];
  if (p.mode === 'quarter') return [0, 1, 2].map(i => ({ y: p.year, m: (p.quarter - 1) * 3 + i + 1 }));
  return Array.from({ length: 12 }, (_, i) => ({ y: p.year, m: i + 1 }));
};
